
export const strongTranslationsFR = {
  "G11": {
    m: "Abraham",
    d: "Le patriarche Abraham, père des croyants.",
    u: "Utilisé 73 fois dans le NT. Modèle de foi.",
    e: "De l'hébreu אַבְרָהָם (Abraham) = père d'une multitude"
  },
  "G25": {
    m: "aimer d'un amour divin et inconditionnel",
    d: "Aimer avec un amour désintéressé, sacrificiel et divin. C'est l'amour de Dieu pour l'humanité et l'amour que nous devons avoir les uns pour les autres.",
    u: "Utilisé 143 fois dans le NT. Décrit l'amour divin, parfait et inconditionnel.",
    e: "De ἄγω (ago) = conduire, diriger vers le bien"
  },
  "G26": {
    m: "amour divin, charité",
    d: "L'amour parfait de Dieu ; amour fraternel, affection, bonne volonté, charité. L'amour qui unit Dieu et l'homme, et l'homme à son prochain.",
    u: "Utilisé 116 fois dans le NT. Le mot central du christianisme pour décrire l'amour divin.",
    e: "Dérivé de ἀγαπάω (agapao)"
  },
  "G27": {
    m: "bien-aimé, cher",
    d: "Aimé, chéri ; bien-aimé de Dieu ou des hommes.",
    u: "Utilisé 61 fois dans le NT. Le Fils bien-aimé de Dieu.",
    e: "De ἀγαπάω (agapao) = aimer"
  },
  "G32": {
    m: "ange, messager",
    d: "Messager ; ange céleste au service de Dieu.",
    u: "Utilisé 175 fois dans le NT. Les anges de Dieu.",
    e: "De ἀγγέλλω (aggello) = annoncer"
  },
  "G36": {
    m: "de basse naissance, ignoble",
    d: "Sans noblesse, de basse extraction ; méprisé.",
    u: "Utilisé 1 fois dans le NT (1 Cor 1:28).",
    e: "De ἀ- (négatif) + γένος (genos) = naissance"
  },
  "G93": {
    m: "injustice, iniquité",
    d: "Violation du droit, injustice ; méchanceté, iniquité morale.",
    u: "Utilisé 25 fois dans le NT. Contraire de δικαιοσύνη (justice).",
    e: "De ἀ- (négatif) + δίκη (dike) = justice"
  },
  "G154": {
    m: "demander, prier, supplier",
    d: "Demander, prier pour quelque chose, supplier, solliciter. Demande humble et respectueuse.",
    u: "Utilisé 70 fois dans le NT. Demande adressée à Dieu ou aux hommes.",
    e: "De αἰτέω (aiteo) racine primitive ; demander"
  },
  "G166": {
    m: "éternel, perpétuel",
    d: "Sans commencement ni fin, qui existe toujours ; dans le NT, souvent lié à la vie éternelle en Dieu.",
    u: "Utilisé 71 fois dans le NT. Qualifie souvent la vie éternelle et le royaume de Dieu.",
    e: "De αἰών (aion) = âge, époque, éternité"
  },
  "G225": {
    m: "vérité, réalité",
    d: "Ce qui est vrai dans les choses concernant Dieu et les devoirs de l'homme ; la vérité divine révélée.",
    u: "Utilisé 109 fois dans le NT. Concept central de l'enseignement de Jésus.",
    e: "De ἀληθής (alethes) = vrai, sincère"
  },
  "G281": {
    m: "amen, en vérité",
    d: "Formule d'affirmation : qu'il en soit ainsi, en vérité, certainement.",
    u: "Utilisé 129 fois dans le NT. Jésus dit 'En vérité, en vérité'.",
    e: "De l'hébreu אָמֵן (amen) = ferme, fidèle"
  },
  "G444": {
    m: "homme, être humain",
    d: "Être humain, homme ou femme ; l'humanité en général.",
    u: "Utilisé 550 fois dans le NT. L'homme créé à l'image de Dieu.",
    e: "De ἀνήρ (aner) = homme et ὤψ (ops) = visage"
  },
  "G622": {
    m: "perdre, détruire, périr",
    d: "Détruire complètement ; perdre, périr ; être ruiné.",
    u: "Utilisé 90 fois dans le NT. Sauver ce qui était perdu.",
    e: "De ἀπό (apo) = de + ὄλλυμι (ollumi) = détruire"
  },
  "G649": {
    m: "envoyer, déléguer",
    d: "Envoyer avec une mission ; déléguer comme ambassadeur.",
    u: "Utilisé 132 fois dans le NT. Le Père envoie le Fils.",
    e: "De ἀπό (apo) = de + στέλλω (stello) = envoyer"
  },
  "G721": {
    m: "agneau",
    d: "Petit agneau ; désigne Jésus-Christ comme l'Agneau de Dieu.",
    u: "Utilisé 30 fois dans le NT, surtout dans l'Apocalypse.",
    e: "Diminutif de ἀρήν (aren) = agneau"
  },
  "G730": {
    m: "mâle, masculin",
    d: "De sexe masculin, mâle.",
    u: "Utilisé 9 fois dans le NT. Dieu créa l'homme mâle et femelle.",
    e: "Racine primaire"
  },
  "G740": {
    m: "pain",
    d: "Pain, nourriture ; le pain de vie = Christ.",
    u: "Utilisé 97 fois dans le NT. Jésus le pain de vie.",
    e: "De ἄρω (aro) = lever, soulever"
  },
  "G746": {
    m: "commencement, principe",
    d: "Le commencement, l'origine, le premier principe. Dans Jean 1:1-2, désigne le commencement éternel où existait déjà la Parole (Logos).",
    u: "Utilisé 55 fois dans le NT. Mot clé de Jean 1:1 'Au commencement était la Parole'.",
    e: "Mot primaire ; commencement, origine première"
  },
  "G772": {
    m: "faible, malade",
    d: "Sans force, faible ; malade, infirme ; spirituellement faible.",
    u: "Utilisé 25 fois dans le NT. Dieu choisit les faibles du monde.",
    e: "De ἀ- (négatif) + σθένος (sthenos) = force"
  },
  "G907": {
    m: "baptiser, immerger",
    d: "Immerger dans l'eau ; baptiser pour purifier ou initier.",
    u: "Utilisé 77 fois dans le NT. Le baptême chrétien.",
    e: "De βάπτω (bapto) = plonger, immerger"
  },
  "G1080": {
    m: "engendrer, faire naître",
    d: "Engendrer, donner naissance ; naître de nouveau spirituellement.",
    u: "Utilisé 97 fois dans le NT. Naître de Dieu, être né de nouveau.",
    e: "Racine primaire"
  },
  "G1096": {
    m: "devenir, arriver, se faire",
    d: "Devenir, venir à l'existence, arriver, avoir lieu, se produire.",
    u: "Utilisé 678 fois dans le NT. 'Toutes choses ont été faites par elle' (Jean 1:3).",
    e: "De la racine γίνομαι (ginomai) = devenir"
  },
  "G1097": {
    m: "connaître, savoir, comprendre",
    d: "Connaître par expérience personnelle ; comprendre, percevoir, être conscient de.",
    u: "Utilisé 222 fois dans le NT. Connaissance expérientielle, pas seulement intellectuelle.",
    e: "Racine indo-européenne *gen- = engendrer, connaître"
  },
  "G1100": {
    m: "langue, langage",
    d: "Organe de la parole ; langage, dialecte ; don des langues.",
    u: "Utilisé 50 fois dans le NT. Le don des langues.",
    e: "Racine primaire"
  },
  "G1166": {
    m: "montrer, démontrer",
    d: "Exposer aux yeux, montrer ; prouver, démontrer.",
    u: "Utilisé 33 fois dans le NT. Dieu montre sa gloire.",
    e: "Racine primaire"
  },
  "G1208": {
    m: "deuxième, second",
    d: "Le deuxième dans une série ou un ordre.",
    u: "Utilisé 44 fois dans le NT. Le deuxième commandement.",
    e: "De δύο (duo) = deux"
  },
  "G1271": {
    m: "intelligence, pensée",
    d: "La faculté de penser, d'entendre, de comprendre ; l'esprit, la compréhension.",
    u: "Utilisé 12 fois dans le NT. L'esprit renouvelé par Christ.",
    e: "De διά (dia) = à travers + νοῦς (nous) = esprit"
  },
  "G1320": {
    m: "enseignant, maître, docteur",
    d: "Enseignant, instructeur ; un qui enseigne les vérités religieuses.",
    u: "Utilisé 59 fois dans le NT. 'Rabbi, nous savons que tu es un docteur venu de Dieu' (Jean 3:2).",
    e: "De διδάσκω (didasko) = enseigner"
  },
  "G1325": {
    m: "donner, accorder",
    d: "Donner quelque chose à quelqu'un ; accorder, permettre ; livrer.",
    u: "Utilisé 415 fois dans le NT. Dieu donne généreusement.",
    e: "Racine primaire"
  },
  "G1372": {
    m: "avoir soif, désirer ardemment",
    d: "Souffrir de la soif ; désirer ardemment, aspirer à.",
    u: "Utilisé 16 fois dans le NT. Soif spirituelle de Dieu.",
    e: "De δίψα (dipsa) = soif"
  },
  "G1401": {
    m: "esclave, serviteur",
    d: "Esclave, serviteur ; serviteur de Dieu volontaire.",
    u: "Utilisé 124 fois dans le NT. Serviteurs de Christ.",
    e: "De δέω (deo) = lier"
  },
  "G1411": {
    m: "puissance, force, miracle",
    d: "Force, pouvoir, capacité ; acte de puissance, miracle.",
    u: "Utilisé 120 fois dans le NT. La puissance de Dieu, du Saint-Esprit.",
    e: "De δύναμαι (dunamai) = être capable"
  },
  "G1417": {
    m: "deux",
    d: "Le nombre deux ; une paire.",
    u: "Utilisé 135 fois dans le NT. Deux ou trois témoins.",
    e: "Racine primaire"
  },
  "G1473": {
    m: "je, moi",
    d: "Pronom personnel de la première personne du singulier.",
    u: "Utilisé 2567 fois dans le NT. Très fréquent.",
    e: "Pronom primaire"
  },
  "G1484": {
    m: "nation, peuple, païens",
    d: "Peuple, nation ; les nations païennes (non-juifs).",
    u: "Utilisé 162 fois dans le NT. L'évangile pour toutes les nations.",
    e: "Racine primaire"
  },
  "G1492": {
    m: "savoir, voir, connaître",
    d: "Savoir par perception, voir, comprendre, connaître. Connaissance acquise par l'expérience ou la révélation.",
    u: "Utilisé 666 fois dans le NT. Verbe fondamental de la connaissance dans l'Évangile de Jean.",
    e: "Forme parfaite de εἴδω (eido) ; voir, savoir"
  },
  "G1510": {
    m: "être, exister",
    d: "Verbe être dans tous ses sens ; exister, demeurer, avoir lieu.",
    u: "Le verbe le plus utilisé dans le NT (2460+ fois).",
    e: "Racine primaire"
  },
  "G1515": {
    m: "paix",
    d: "État de tranquillité ; paix avec Dieu ; harmonie entre les personnes.",
    u: "Utilisé 92 fois dans le NT. La paix de Christ.",
    e: "De εἴρω (eiro) = joindre, lier"
  },
  "G1520": {
    m: "un, unique",
    d: "Un seul ; unique, seulement ; un certain.",
    u: "Utilisé 344 fois dans le NT. L'unité de Dieu, l'église unie.",
    e: "Racine primaire"
  },
  "G1586": {
    m: "choisir, élire",
    d: "Choisir pour soi, sélectionner ; élire par grâce divine.",
    u: "Utilisé 21 fois dans le NT. Dieu élit ses enfants.",
    e: "De ἐκ (ek) = hors de + λέγω (lego) = choisir"
  },
  "G1658": {
    m: "libre, affranchi",
    d: "Libre, non esclave ; libéré de l'esclavage du péché.",
    u: "Utilisé 23 fois dans le NT. Libérés en Christ.",
    e: "Probablement de ἔρχομαι (erchomai) = venir"
  },
  "G1672": {
    m: "Grec, Gentil",
    d: "Un Grec de naissance ou de langue ; un non-Juif.",
    u: "Utilisé 25 fois dans le NT. Ni Juif ni Grec en Christ.",
    e: "De Ἑλλάς (Hellas) = Grèce"
  },
  "G1680": {
    m: "espérance, attente confiante",
    d: "Attente de bonnes choses, espoir fondé sur Dieu ; confiance dans l'avenir basée sur les promesses divines.",
    u: "Utilisé 54 fois dans le NT. Une des trois vertus théologales avec la foi et l'amour.",
    e: "De ἔλπω (elpo) = attendre, espérer"
  },
  "G1743": {
    m: "fortifier, rendre fort",
    d: "Rendre fort, fortifier ; donner de la puissance.",
    u: "Utilisé 8 fois dans le NT. Dieu fortifie les croyants.",
    e: "De ἐν (en) = dans + δυναμόω (dynamoo) = rendre puissant"
  },
  "G1746": {
    m: "revêtir, s'habiller",
    d: "Mettre un vêtement ; revêtir d'une qualité ou d'un pouvoir.",
    u: "Utilisé 27 fois dans le NT. Revêtir Christ, revêtir l'armure de Dieu.",
    e: "De ἐν (en) = dans + δύω (duo) = entrer, revêtir"
  },
  "G1785": {
    m: "commandement, ordre",
    d: "Un ordre, commandement, précepte ; spécialement un commandement divin.",
    u: "Utilisé 67 fois dans le NT. Les commandements de Dieu et de Christ.",
    e: "De ἐντέλλομαι (entellomai) = commander"
  },
  "G1848": {
    m: "mépriser, traiter avec mépris",
    d: "Considérer comme rien, mépriser ; traiter avec dédain.",
    u: "Utilisé 11 fois dans le NT. Le monde méprise ce que Dieu choisit.",
    e: "De ἐξ (ex) = hors de + οὐθείς (outheis) = personne"
  },
  "G2041": {
    m: "œuvre, travail, acte",
    d: "Travail, labeur ; action, acte ; œuvre accomplie.",
    u: "Utilisé 169 fois dans le NT. Les œuvres de Dieu, les bonnes œuvres.",
    e: "De ἔργω (ergo) = travailler"
  },
  "G2048": {
    m: "désert, solitaire",
    d: "Lieu désert, wilderness ; solitaire, dépeuplé.",
    u: "Utilisé 48 fois dans le NT. Les 40 jours de Jésus au désert.",
    e: "De ἔρημος (eremos) = abandonné"
  },
  "G2065": {
    m: "questionner, interroger, demander",
    d: "Questionner, interroger, demander des informations. Enquête ou investigation.",
    u: "Utilisé 63 fois dans le NT. Questionner pour obtenir des réponses.",
    e: "Racine incertaine ; questionner, interroger"
  },
  "G2189": {
    m: "inimitié, hostilité",
    d: "Haine, hostilité, inimitié.",
    u: "Utilisé 6 fois dans le NT. L'inimitié avec Dieu abolie.",
    e: "De ἐχθρός (echthros) = ennemi"
  },
  "G2205": {
    m: "zèle, jalousie, envie",
    d: "Ardeur passionnée ; peut être positive (zèle pour Dieu) ou négative (jalousie, envie).",
    u: "Utilisé 16 fois dans le NT. Peut être vertueux ou vicieux selon le contexte.",
    e: "De ζέω (zeo) = bouillir, être fervent"
  },
  "G2222": {
    m: "vie",
    d: "Vie physique ou spirituelle ; la vie éternelle en Dieu.",
    u: "Utilisé 135 fois dans le NT. Jésus est la vie.",
    e: "De ζάω (zao) = vivre"
  },
  "G2258": {
    m: "était, il était",
    d: "Était, il était, elle était. Forme d'imparfait du verbe être (εἰμί). Exprime un état ou une existence dans le passé.",
    u: "Utilisé 267 fois dans le NT. Crucial dans Jean 1:1 'Au commencement était la Parole'.",
    e: "Imparfait de εἰμί (eimi) = être ; était"
  },
  "G2296": {
    m: "s'étonner, s'émerveiller, admirer",
    d: "S'étonner, s'émerveiller, être surpris, admirer. Réaction d'étonnement face à quelque chose d'extraordinaire.",
    u: "Utilisé 43 fois dans le NT. Réaction fréquente aux miracles et enseignements de Jésus.",
    e: "De θαῦμα (thauma) = merveille ; s'émerveiller"
  },
  "G2316": {
    m: "Dieu, divinité",
    d: "La Divinité suprême - spécialement (avec l'article) le Dieu unique et véritable. Dans l'Écriture, révèle le Dieu unique qui se manifeste comme Père, Fils et Saint-Esprit, sans division de l'essence divine.",
    u: "Utilisé 1343 fois dans le NT selon les sources bibliques. Mot central désignant le seul vrai Dieu et Ses œuvres.",
    e: "D'affinité incertaine selon Strong. Désigne une divinité, particulièrement la Divinité suprême. Usage biblique : révèle le Dieu vivant qui agit dans l'histoire du salut."
  },
  "G2338": {
    m: "femelle, féminin",
    d: "De sexe féminin, femelle.",
    u: "Utilisé 5 fois dans le NT. Homme et femme égaux en Christ.",
    e: "De θηλάζω (thelazo) = allaiter"
  },
  "G2362": {
    m: "trône",
    d: "Siège royal, trône ; pouvoir et autorité royale.",
    u: "Utilisé 62 fois dans le NT. Le trône de Dieu et de l'Agneau.",
    e: "Racine primaire"
  },
  "G2381": {
    m: "Thomas",
    d: "Thomas, nom propre. L'un des douze apôtres, appelé aussi Didyme (jumeau). Connu pour sa demande de preuves de la résurrection.",
    u: "Utilisé 11 fois dans le NT. L'apôtre qui a douté puis cru.",
    e: "De l'araméen תְּאוֹמָא (teoma) = jumeau"
  },
  "G2398": {
    m: "propre, particulier, personnel",
    d: "Propre, particulier, personnel, privé. Ce qui appartient en propre à quelqu'un, distinct des autres.",
    u: "Utilisé 114 fois dans le NT. Concept d'appartenance personnelle et de distinction.",
    e: "De racine incertaine ; propre, particulier"
  },
  "G2424": {
    m: "Jésus",
    d: "Jésus de Nazareth, le Messie, le Sauveur.",
    u: "Utilisé 917 fois dans le NT. Le nom au-dessus de tout nom.",
    e: "De l'hébreu יְהוֹשֻׁעַ (Yehoshua) = YHWH sauve"
  },
  "G2453": {
    m: "Juif, Judéen",
    d: "Appartenant à la race juive ; habitant de la Judée.",
    u: "Utilisé 195 fois dans le NT. Les Juifs, peuple élu de Dieu.",
    e: "De Ἰούδας (Ioudas) = Juda"
  },
  "G2491": {
    m: "Jean",
    d: "Jean, nom propre. Jean-Baptiste le précurseur, Jean l'apôtre bien-aimé, auteur de l'Évangile et des épîtres.",
    u: "Utilisé 135 fois dans le NT. Nom de deux grandes figures du NT.",
    e: "De l'hébreu יוֹחָנָן (Yochanan) = YHWH fait grâce"
  },
  "G2531": {
    m: "comme, selon que",
    d: "Comme, de la même manière que ; selon que, dans la mesure où.",
    u: "Utilisé 182 fois dans le NT. Conjonction comparative.",
    e: "De κατά (kata) = selon + ὡς (hos) = comme"
  },
  "G2537": {
    m: "nouveau, récent",
    d: "Nouveau dans le temps ou la qualité ; frais, récent, non usé.",
    u: "Utilisé 42 fois dans le NT. Nouvelle création, nouveau commandement.",
    e: "Racine incertaine"
  },
  "G2570": {
    m: "bon, beau",
    d: "Bon dans sa nature, beau ; honorable, excellent, vertueux.",
    u: "Utilisé 100 fois dans le NT. Le bon berger, les bonnes œuvres.",
    e: "Racine primaire"
  },
  "G2588": {
    m: "cœur",
    d: "Le cœur physique ; le centre de la vie intérieure, l'âme, l'esprit ; les pensées et les sentiments.",
    u: "Utilisé 156 fois dans le NT. Siège de la vie spirituelle.",
    e: "Racine primaire"
  },
  "G2596": {
    m: "selon, contre, à travers",
    d: "Préposition avec plusieurs sens : selon, conformément à ; contre ; à travers.",
    u: "Utilisé plus de 470 fois dans le NT. Préposition très fréquente.",
    e: "Préposition primaire"
  },
  "G2617": {
    m: "faire honte, déshonorer",
    d: "Faire honte, déshonorer ; confondre, humilier.",
    u: "Utilisé 13 fois dans le NT. Dieu confond les sages du monde.",
    e: "De κατά (kata) = contre + αἰσχύνω (aischuno) = avoir honte"
  },
  "G2744": {
    m: "se glorifier, se vanter",
    d: "Se glorifier, se vanter ; trouver sa fierté en quelque chose.",
    u: "Utilisé 37 fois dans le NT. Se glorifier dans le Seigneur.",
    e: "De καῦχος (kauchos) = vantardise"
  },
  "G2889": {
    m: "monde, univers, humanité",
    d: "L'ordre du monde, l'univers ; l'humanité déchue ; le système opposé à Dieu.",
    u: "Utilisé 186 fois dans le NT. Peut désigner la création ou le système pécheur.",
    e: "De κοσμέω (kosmeo) = orner, arranger"
  },
  "G2919": {
    m: "juger, décider",
    d: "Juger, prononcer un jugement ; décider, déterminer.",
    u: "Utilisé 114 fois dans le NT. Dieu juge le monde.",
    e: "Racine primaire"
  },
  "G2920": {
    m: "jugement, justice, condamnation",
    d: "Jugement, justice, condamnation, décision judiciaire. Le jugement de Dieu, juste et parfait.",
    u: "Utilisé 47 fois dans le NT. Concept central de la justice divine.",
    e: "De κρίνω (krino) = juger, décider"
  },
  "G2962": {
    m: "Seigneur, Maître, propriétaire",
    d: "Seigneur, Maître ; titre de respect et d'autorité divine ; Jésus comme Seigneur.",
    u: "Utilisé 748 fois dans le NT. 'Thomas lui dit: Seigneur, nous ne savons où tu vas' (Jean 14:5).",
    e: "De κύριος (kurios) = avoir autorité"
  },
  "G2992": {
    m: "peuple",
    d: "Un peuple, une nation ; spécialement le peuple de Dieu (Israël ou l'Église).",
    u: "Utilisé 142 fois dans le NT. Le peuple élu de Dieu.",
    e: "Racine primaire"
  },
  "G3022": {
    m: "blanc, brillant",
    d: "Blanc, éclatant ; symbole de pureté et de victoire.",
    u: "Utilisé 25 fois dans le NT. Les vêtements blancs des rachetés.",
    e: "De λευκός (leukos) = blanc, lumineux"
  },
  "G3056": {
    m: "parole, mot, raison",
    d: "Parole prononcée ; raison, intelligence ; le Logos = Christ.",
    u: "Utilisé 330 fois dans le NT. Le Logos incarné.",
    e: "De λέγω (lego) = dire"
  },
  "G3101": {
    m: "disciple, élève",
    d: "Un apprenant, étudiant, disciple ; suiveur de Jésus.",
    u: "Utilisé 261 fois dans le NT. Désigne les suiveurs de Christ.",
    e: "De μανθάνω (manthano) = apprendre"
  },
  "G3141": {
    m: "témoignage, attestation",
    d: "Témoignage, attestation, preuve. Témoignage rendu à la vérité, particulièrement au Christ.",
    u: "Utilisé 37 fois dans le NT. Thème majeur de l'Évangile de Jean.",
    e: "De μάρτυς (martus) = témoin"
  },
  "G3173": {
    m: "grand, important",
    d: "Grand en taille, en quantité ou en importance ; puissant, merveilleux.",
    u: "Utilisé 243 fois dans le NT. La grandeur de Dieu.",
    e: "Racine primaire"
  },
  "G3320": {
    m: "mur de séparation",
    d: "Mur mitoyen, cloison de séparation.",
    u: "Utilisé 1 fois dans le NT (Éph 2:14). Le mur entre Juifs et Gentils.",
    e: "De μέσος (mesos) = milieu + τοῖχος (toichos) = mur"
  },
  "G3439": {
    m: "unique, seul engendré",
    d: "Unique en son genre, seul engendré ; unique fils.",
    u: "Utilisé 9 fois dans le NT. Le Fils unique de Dieu.",
    e: "De μόνος (monos) = seul + γίνομαι (ginomai) = devenir"
  },
  "G3474": {
    m: "folie, sottise",
    d: "Folie, absurdité ; ce qui manque de sagesse.",
    u: "Utilisé 5 fois dans le NT. La sagesse de Dieu paraît folie au monde.",
    e: "De μωρός (moros) = fou, insensé"
  },
  "G3475": {
    m: "Moïse",
    d: "Moïse, le législateur d'Israël.",
    u: "Utilisé 80 fois dans le NT. La loi de Moïse.",
    e: "De l'hébreu מֹשֶׁה (Mosheh) = tiré (des eaux)"
  },
  "G3530": {
    m: "Nicodème",
    d: "Nicodème, nom propre. Pharisien et dirigeant juif qui vint voir Jésus de nuit. Nom grec signifiant 'victoire du peuple'.",
    u: "Utilisé 5 fois dans le NT. Personnage important dans l'Évangile de Jean.",
    e: "Du grec νίκη (nikē) = victoire et δῆμος (dēmos) = peuple"
  },
  "G3551": {
    m: "loi, Torah",
    d: "Loi, Torah, règle, principe. La loi de Moïse, la loi divine, les commandements de Dieu.",
    u: "Utilisé 194 fois dans le NT. Concept central de la révélation divine.",
    e: "De νέμω (nemo) = distribuer, donner ; loi donnée"
  },
  "G3571": {
    m: "nuit",
    d: "Nuit, période d'obscurité entre le coucher et le lever du soleil. Souvent métaphorique pour l'ignorance spirituelle.",
    u: "Utilisé 61 fois dans le NT. Contrastée avec la lumière dans la symbolique johannique.",
    e: "Nom féminin primaire ; nuit"
  },
  "G3598": {
    m: "chemin, voie",
    d: "Route, chemin ; manière de vivre, conduite ; la voie du salut.",
    u: "Utilisé 101 fois dans le NT. Jésus est le chemin.",
    e: "Racine primaire"
  },
  "G3609": {
    m: "domestique, de la maison",
    d: "Appartenant à la maison, membre de la famille ; serviteur domestique.",
    u: "Utilisé 3 fois dans le NT. Décrit les membres de la famille de Dieu.",
    e: "De οἶκος (oikos) = maison"
  },
  "G3664": {
    m: "semblable, pareil",
    d: "Semblable, de même nature ou caractère ; équivalent.",
    u: "Utilisé 45 fois dans le NT. Le deuxième commandement semblable au premier.",
    e: "De ὁμός (homos) = même"
  },
  "G3686": {
    m: "nom",
    d: "Nom, titre ; réputation ; autorité, pouvoir.",
    u: "Utilisé 228 fois dans le NT. Le nom de Jésus.",
    e: "Racine primaire"
  },
  "G3708": {
    m: "voir, regarder",
    d: "Voir avec les yeux ; percevoir, comprendre ; apparaître.",
    u: "Utilisé 454 fois dans le NT. Voir Christ, voir le Père.",
    e: "Racine primaire"
  },
  "G3735": {
    m: "montagne, colline",
    d: "Montagne, mont ; colline élevée.",
    u: "Utilisé 63 fois dans le NT. La montagne de la transfiguration.",
    e: "Probablement de ὁράω (horao) = voir"
  },
  "G3756": {
    m: "ne... pas, non",
    d: "Négation absolue, non, pas.",
    u: "Utilisé plus de 1600 fois dans le NT. Particule de négation très fréquente.",
    e: "Particule primaire de négation"
  },
  "G3762": {
    m: "personne, rien, aucun",
    d: "Personne, rien, aucun, nul. Négation absolue de l'existence ou de la quantité.",
    u: "Utilisé 234 fois dans le NT. Négation forte très courante.",
    e: "De οὐδέ (oude) et εἷς (heis) ; pas même un"
  },
  "G3778": {
    m: "celui-ci, cette, ceci",
    d: "Pronom démonstratif : celui-ci, cette, ceci. Désigne quelque chose de proche ou de précédemment mentionné.",
    u: "Utilisé 1388 fois dans le NT. Pronom démonstratif le plus fréquent.",
    e: "Pronom démonstratif primaire"
  },
  "G3789": {
    m: "serpent",
    d: "Serpent, reptile ; le serpent ancien (Satan).",
    u: "Utilisé 14 fois dans le NT. Le serpent d'airain dans le désert.",
    e: "Racine primaire"
  },
  "G3793": {
    m: "foule, multitude",
    d: "Foule de gens, multitude ; la masse populaire.",
    u: "Utilisé 175 fois dans le NT. Les foules qui suivaient Jésus.",
    e: "De ὄχος (ochos) = véhicule (qui transporte)"
  },
  "G3880": {
    m: "recevoir, prendre, accepter",
    d: "Recevoir, prendre, accepter, saisir. Recevoir quelque chose qui est offert ou donné.",
    u: "Utilisé 59 fois dans le NT. Concept central de l'acceptation de l'Évangile.",
    e: "De παρά (para) = auprès de et λαμβάνω (lambanō) = prendre"
  },
  "G3956": {
    m: "tout, chaque",
    d: "Tout, chaque, tous ; l'ensemble, la totalité.",
    u: "Utilisé 1244 fois dans le NT. Parmi les mots les plus fréquents.",
    e: "Racine primaire"
  },
  "G3962": {
    m: "père",
    d: "Un père naturel ou spirituel ; ancêtre ; Dieu le Père.",
    u: "Utilisé 413 fois dans le NT. Souvent pour désigner Dieu.",
    e: "Racine primaire apparentée au latin 'pater'"
  },
  "G4100": {
    m: "croire, avoir foi",
    d: "Avoir foi en, croire ; se confier en, s'appuyer sur.",
    u: "Utilisé 241 fois dans le NT. Croire en Jésus pour être sauvé.",
    e: "De πίστις (pistis) = foi"
  },
  "G4102": {
    m: "foi, confiance, fidélité",
    d: "Conviction de la vérité de quoi que ce soit, croyance ; dans le NT d'une conviction concernant la relation de l'homme avec Dieu et les choses divines.",
    u: "Utilisé 244 fois dans le NT. Concept central de la foi chrétienne.",
    e: "De πείθω (peitho) = persuader, convaincre"
  },
  "G4138": {
    m: "plénitude, abondance, ce qui remplit",
    d: "Plénitude, abondance, ce qui remplit complètement. La totalité, la complétude divine.",
    u: "Utilisé 17 fois dans le NT. Concept théologique de la plénitude divine en Christ.",
    e: "De πλήρης (plērēs) = plein ; plénitude"
  },
  "G4139": {
    m: "prochain, voisin",
    d: "Celui qui est proche, le voisin ; le prochain en général.",
    u: "Utilisé 17 fois dans le NT. 'Aimer ton prochain comme toi-même'.",
    e: "Adverbe devenu nom, de πλησίος (plesios) = près"
  },
  "G4151": {
    m: "esprit, souffle, vent",
    d: "Le souffle de vie, le principe vital ; l'âme rationnelle ; le Saint-Esprit.",
    u: "Utilisé 385 fois dans le NT. Désigne l'Esprit Saint, l'esprit humain ou des esprits.",
    e: "De πνέω (pneo) = souffler, respirer"
  },
  "G4160": {
    m: "faire, accomplir, agir",
    d: "Faire, accomplir, produire, agir, créer. Verbe d'action générale couvrant tout type d'activité.",
    u: "Utilisé 568 fois dans le NT. Verbe d'action fondamental, souvent dans les œuvres de Dieu.",
    e: "Verbe primaire ; faire, accomplir"
  },
  "G4166": {
    m: "berger, pasteur",
    d: "Celui qui garde les brebis ; gardien spirituel, pasteur d'église.",
    u: "Utilisé 18 fois dans le NT. Jésus le bon berger.",
    e: "De ποίμνη (poimne) = troupeau"
  },
  "G4183": {
    m: "beaucoup, nombreux, grand",
    d: "Beaucoup, nombreux, grand en quantité ou en nombre. Multitude, grande quantité.",
    u: "Utilisé 416 fois dans le NT. Adjectif quantitatif très fréquent.",
    e: "Racine incertaine ; beaucoup, nombreux"
  },
  "G4198": {
    m: "aller, marcher, voyager",
    d: "Aller, marcher, voyager, se déplacer. Mouvement d'un lieu à un autre, souvent avec un but.",
    u: "Utilisé 154 fois dans le NT. Verbe de mouvement fondamental dans les récits évangéliques.",
    e: "Verbe primaire ; aller, marcher"
  },
  "G4238": {
    m: "faire, pratiquer, accomplir",
    d: "Faire, pratiquer, accomplir, agir. Accomplir des actions, souvent avec l'idée de répétition ou d'habitude.",
    u: "Utilisé 39 fois dans le NT. Souvent lié à la pratique du bien ou du mal.",
    e: "Forme renforcée de πράω (praō) ; faire, pratiquer"
  },
  "G4263": {
    m: "brebis, mouton",
    d: "Brebis ou mouton ; métaphoriquement, les disciples de Christ.",
    u: "Utilisé 39 fois dans le NT. Les croyants comme brebis du berger.",
    e: "Probablement lié à προβαίνω (probaino) = avancer"
  },
  "G4413": {
    m: "premier, principal",
    d: "Premier dans le temps, le lieu, l'ordre ou l'importance.",
    u: "Utilisé 155 fois dans le NT. Le premier commandement, la première place.",
    e: "Superlatif de πρό (pro) = avant"
  },
  "G4561": {
    m: "chair, corps",
    d: "Chair, viande ; le corps humain ; la nature humaine déchue.",
    u: "Utilisé 147 fois dans le NT. Contraste entre chair et esprit.",
    e: "Racine primaire"
  },
  "G4592": {
    m: "signe, miracle, prodige",
    d: "Signe, miracle, prodige ; manifestation surnaturelle révélant la puissance divine.",
    u: "Utilisé 77 fois dans le NT. 'car personne ne peut faire ces miracles que tu fais' (Jean 3:2).",
    e: "De σημεῖον (semeion) = marque, signe"
  },
  "G4648": {
    m: "regarder attentivement, viser",
    d: "Fixer les yeux sur, considérer attentivement ; avoir en vue, viser un but.",
    u: "Utilisé 6 fois dans le NT. Appel à fixer les yeux sur Christ.",
    e: "Lié à σκοπός (skopos) = cible, but"
  },
  "G4680": {
    m: "sage, savant",
    d: "Sage, intelligent, habile ; formé, instruit.",
    u: "Utilisé 22 fois dans le NT. La vraie sagesse vient de Dieu.",
    e: "Racine primaire"
  },
  "G4982": {
    m: "sauver, délivrer",
    d: "Sauver de danger ou destruction ; délivrer du péché.",
    u: "Utilisé 106 fois dans le NT. Jésus sauve les pécheurs.",
    e: "De σῶς (sos) = sain et sauf"
  },
  "G5040": {
    m: "petit enfant",
    d: "Petit enfant, enfant en bas âge ; terme affectueux pour disciple.",
    u: "Utilisé 8 fois dans le NT. Jean appelle ses lecteurs 'petits enfants'.",
    e: "Diminutif de τέκνον (teknon) = enfant"
  },
  "G5087": {
    m: "placer, poser, établir",
    d: "Mettre, placer ; établir, nommer ; déposer, poser.",
    u: "Utilisé 100 fois dans le NT. Poser sa vie pour les brebis.",
    e: "Racine primaire"
  },
  "G5109": {
    m: "mur",
    d: "Mur de séparation, paroi.",
    u: "Utilisé 1 fois dans le NT (Actes 23:3).",
    e: "Racine primaire"
  },
  "G5207": {
    m: "fils",
    d: "Descendant mâle ; disciple ; membre d'un groupe. Le Fils de Dieu = Jésus-Christ.",
    u: "Utilisé 377 fois dans le NT. Souvent pour désigner Jésus comme Fils de Dieu.",
    e: "Origine incertaine, peut-être lié à ὕω (huo) = faire pleuvoir, engendrer"
  },
  "G5281": {
    m: "patience, endurance, persévérance",
    d: "Qualité de celui qui ne succombe pas aux circonstances ou aux pressions ; endurance patiente, constance.",
    u: "Utilisé 32 fois dans le NT. Vertu chrétienne essentielle.",
    e: "De ὑπό (hupo) = sous et μένω (meno) = demeurer"
  },
  "G5312": {
    m: "élever, exalter",
    d: "Lever en haut, élever ; exalter, honorer.",
    u: "Utilisé 20 fois dans le NT. Le Fils de l'homme élevé.",
    e: "De ὕψος (hupsos) = hauteur"
  },
  "G5376": {
    m: "Philippe",
    d: "Philippe, nom propre. L'un des douze apôtres. Nom grec signifiant 'ami des chevaux'.",
    u: "Utilisé 36 fois dans le NT. Nom de l'apôtre et du diacre.",
    e: "Du grec φίλος (philos) = ami et ἵππος (hippos) = cheval"
  },
  "G5432": {
    m: "garder, protéger",
    d: "Garder par une garde militaire ; protéger, préserver.",
    u: "Utilisé 4 fois dans le NT. La paix de Dieu garde nos cœurs.",
    e: "De φρουρός (phrouros) = garde, sentinelle"
  },
  "G5443": {
    m: "tribu, peuple",
    d: "Tribu, clan ; un peuple descendant d'un ancêtre commun.",
    u: "Utilisé 31 fois dans le NT. Les douze tribus d'Israël.",
    e: "De φύω (phuo) = produire, faire croître"
  },
  "G5457": {
    m: "lumière",
    d: "Lumière physique ou spirituelle ; la vérité divine révélée.",
    u: "Utilisé 73 fois dans le NT. Jésus lumière du monde.",
    e: "De φάω (phao) = briller"
  },
  "G5463": {
    m: "se réjouir, être joyeux",
    d: "Se réjouir, être heureux ; salutation 'réjouis-toi' ou 'salut'.",
    u: "Utilisé 74 fois dans le NT. Commande fréquente de se réjouir en Christ.",
    e: "Apparenté à χάρις (charis) = grâce"
  },
  "G5495": {
    m: "main",
    d: "La main ; pouvoir, autorité ; action, œuvre.",
    u: "Utilisé 177 fois dans le NT. La main de Dieu, les mains de Jésus.",
    e: "Racine primaire"
  },
  "G5544": {
    m: "bonté, bienveillance",
    d: "Bonté en action, bienveillance pratique ; qualité de celui qui est utile, profitable aux autres.",
    u: "Utilisé 10 fois dans le NT. Fruit de l'Esprit selon Galates 5:22.",
    e: "De χρηστός (chrestos) = bon, utile, bienveillant"
  },
  "G5547": {
    m: "Christ, Messie, Oint",
    d: "L'Oint, le Messie ; titre de Jésus comme Sauveur promis.",
    u: "Utilisé 529 fois dans le NT. Jésus est le Christ.",
    e: "De χρίω (chrio) = oindre"
  },
  "G5590": {
    m: "âme, vie",
    d: "Le souffle de vie, l'âme vitale ; la vie elle-même ; l'âme immortelle.",
    u: "Utilisé 105 fois dans le NT. La vie spirituelle et éternelle.",
    e: "De ψύχω (psucho) = respirer, rafraîchir"
  },
  "H120": {
    m: "homme, humanité, Adam",
    d: "Homme, être humain ; l'humanité ; Adam le premier homme.",
    u: "Utilisé 562 fois dans l'AT. Dieu créa l'homme.",
    e: "De אָדֹם (adom) = rouge, ou אֲדָמָה (adamah) = terre"
  },
  "H160": {
    m: "amour, affection",
    d: "Amour, affection ; acte d'amour.",
    u: "Utilisé 40 fois dans l'AT. L'amour de Dieu pour son peuple.",
    e: "De אָהַב (ahab) = aimer"
  },
  "H216": {
    m: "lumière",
    d: "Lumière naturelle ou spirituelle ; bonheur, prospérité.",
    u: "Utilisé 120 fois dans l'AT. 'Que la lumière soit !'",
    e: "De אוֹר (or) = être lumineux"
  },
  "H430": {
    m: "Dieu, dieux",
    d: "Le Dieu suprême (Elohim) ; parfois utilisé pour les juges ou les dieux païens.",
    u: "Utilisé 2606 fois dans l'AT. Nom pluriel de majesté pour Dieu.",
    e: "Pluriel de אֱלוֹהַּ (eloah) = dieu"
  },
  "H559": {
    m: "dire, parler",
    d: "Dire, parler, déclarer ; commander, penser.",
    u: "Utilisé 5316 fois dans l'AT. Le verbe de parole le plus fréquent.",
    e: "Racine primaire"
  },
  "H776": {
    m: "terre, pays",
    d: "Terre, sol ; pays, région ; le monde terrestre.",
    u: "Utilisé 2504 fois dans l'AT. La terre que Dieu créa.",
    e: "Racine primaire"
  },
  "H982": {
    m: "se confier, avoir confiance",
    d: "Se confier en, avoir confiance ; être en sécurité.",
    u: "Utilisé 120 fois dans l'AT. Confiance en l'Éternel.",
    e: "Racine primaire"
  },
  "H1004": {
    m: "maison, demeure",
    d: "Maison, habitation ; famille, maisonnée ; temple.",
    u: "Utilisé 2055 fois dans l'AT. La maison de l'Éternel.",
    e: "De בָּנָה (banah) = construire"
  },
  "H1254": {
    m: "créer",
    d: "Créer du néant ; former, faire ; activité exclusive de Dieu.",
    u: "Utilisé 54 fois dans l'AT. Dieu créa les cieux et la terre.",
    e: "Racine primaire"
  },
  "H1516": {
    m: "vallée, ravin",
    d: "Vallée, gorge, ravin ; plaine.",
    u: "Utilisé 60 fois dans l'AT. La vallée de l'ombre de la mort.",
    e: "Racine primaire"
  },
  "H1878": {
    m: "engraisser, rendre gras",
    d: "Rendre gras, engraisser ; prospérer.",
    u: "Utilisé 11 fois dans l'AT. Tu oins ma tête d'huile.",
    e: "De דֶּשֶׁן (deshen) = graisse, cendres"
  },
  "H1980": {
    m: "marcher, aller",
    d: "Marcher, aller, venir ; vivre, se conduire.",
    u: "Utilisé 1554 fois dans l'AT. Verbe de mouvement très fréquent.",
    e: "Racine primaire"
  },
  "H2617": {
    m: "bonté, miséricorde, fidélité",
    d: "Bonté, miséricorde ; fidélité à l'alliance ; amour loyal.",
    u: "Utilisé 248 fois dans l'AT. La bonté de l'Éternel.",
    e: "De חָסַד (chasad) = être bon, miséricordieux"
  },
  "H2637": {
    m: "manquer, avoir besoin",
    d: "Manquer de, avoir besoin ; diminuer, faire défaut.",
    u: "Utilisé 23 fois dans l'AT. Je ne manquerai de rien (Ps 23:1).",
    e: "Racine primaire"
  },
  "H2896": {
    m: "bon, bien",
    d: "Bon, agréable, excellent ; bienveillant, juste.",
    u: "Utilisé 559 fois dans l'AT. Dieu vit que cela était bon.",
    e: "Racine primaire"
  },
  "H3068": {
    m: "YHWH, l'Éternel",
    d: "Le nom propre de Dieu, tétragramme sacré YHWH.",
    u: "Utilisé 6828 fois dans l'AT. Le nom le plus saint.",
    e: "De הָיָה (hayah) = être, exister"
  },
  "H3117": {
    m: "jour",
    d: "Jour (opposé à la nuit) ; période de 24 heures ; époque, temps.",
    u: "Utilisé 2301 fois dans l'AT. Le jour que l'Éternel a fait.",
    e: "De יוֹם (yowm) = être chaud"
  },
  "H3372": {
    m: "craindre, avoir peur, révérer",
    d: "Craindre, avoir peur ; révérer, respecter Dieu.",
    u: "Utilisé 335 fois dans l'AT. Je ne crains aucun mal.",
    e: "Racine primaire"
  },
  "H3563": {
    m: "coupe, calice",
    d: "Coupe, calice ; portion, sort.",
    u: "Utilisé 31 fois dans l'AT. Ma coupe déborde.",
    e: "Racine primaire"
  },
  "H3820": {
    m: "cœur, esprit",
    d: "Cœur, siège des émotions ; esprit, intelligence, volonté.",
    u: "Utilisé 598 fois dans l'AT. Le cœur de l'homme.",
    e: "Racine primaire"
  },
  "H3915": {
    m: "nuit",
    d: "Nuit (opposée au jour) ; temps d'obscurité.",
    u: "Utilisé 234 fois dans l'AT. Dieu sépara le jour et la nuit.",
    e: "Racine primaire"
  },
  "H3966": {
    m: "très, extrêmement",
    d: "Très, extrêmement, beaucoup ; avec force, rapidement.",
    u: "Utilisé 300 fois dans l'AT. Cela était très bon.",
    e: "De מָאַד (ma'ad) = être nombreux"
  },
  "H4325": {
    m: "eau, eaux",
    d: "Eau, eaux ; pluie ; flot, mer.",
    u: "Utilisé 585 fois dans l'AT. Les eaux de la création.",
    e: "Duel de מַיִם (mayim) = eau"
  },
  "H4999": {
    m: "pâturage, demeure",
    d: "Lieu de pâturage, prairie ; habitation, demeure.",
    u: "Utilisé 13 fois dans l'AT. Dans de verts pâturages.",
    e: "De נָאָה (na'ah) = être beau, convenable"
  },
  "H5148": {
    m: "conduire, guider",
    d: "Conduire, guider, diriger ; mener en sûreté.",
    u: "Utilisé 40 fois dans l'AT. Il me conduit (Ps 23:3).",
    e: "Racine primaire"
  },
  "H5216": {
    m: "pâturage, terre cultivée",
    d: "Prairie, pâturage ; terre cultivée, champ.",
    u: "Utilisé 2 fois dans l'AT. Pâturages verdoyants.",
    e: "De נִיר (niyr) = labourer"
  },
  "H5315": {
    m: "âme, vie, personne",
    d: "Âme, vie, être vivant ; personne, soi ; désir, appétit.",
    u: "Utilisé 753 fois dans l'AT. Mon âme, ma vie.",
    e: "De נָפַשׁ (naphash) = respirer"
  },
  "H5769": {
    m: "éternité, toujours",
    d: "Temps indéfini, éternité ; toujours, perpétuité.",
    u: "Utilisé 439 fois dans l'AT. L'amour éternel de Dieu.",
    e: "De עָלַם (alam) = cacher, être caché"
  },
  "H6186": {
    m: "arranger, disposer",
    d: "Arranger en ordre, disposer ; préparer une table.",
    u: "Utilisé 75 fois dans l'AT. Tu dresses une table (Ps 23:5).",
    e: "Racine primaire"
  },
  "H6213": {
    m: "faire, accomplir",
    d: "Faire, fabriquer, accomplir ; agir, travailler.",
    u: "Utilisé 2632 fois dans l'AT. Verbe très fréquent.",
    e: "Racine primaire"
  },
  "H6664": {
    m: "justice, droiture",
    d: "Justice, droiture, équité ; fidélité.",
    u: "Utilisé 119 fois dans l'AT. Sentiers de justice.",
    e: "De צָדַק (tsadaq) = être juste"
  },
  "H6754": {
    m: "image, ressemblance",
    d: "Image, ressemblance ; forme, apparence.",
    u: "Utilisé 17 fois dans l'AT. L'homme créé à l'image de Dieu.",
    e: "De צָלַל (tsalal) = ombrer, ressembler"
  },
  "H6757": {
    m: "ombre de la mort, obscurité profonde",
    d: "Ténèbres profondes, obscurité mortelle ; ombre de la mort.",
    u: "Utilisé 18 fois dans l'AT. Symbolise le danger extrême.",
    e: "De צֵל (tsel) = ombre + מָוֶת (maveth) = mort"
  },
  "H6887": {
    m: "être dans la détresse, adversaire",
    d: "Être serré, en détresse ; adversaire, ennemi.",
    u: "Utilisé 58 fois dans l'AT. En présence de mes adversaires.",
    e: "Racine primaire"
  },
  "H7121": {
    m: "appeler, crier, proclamer",
    d: "Appeler, crier ; nommer ; proclamer, convoquer.",
    u: "Utilisé 736 fois dans l'AT. Appeler le nom de l'Éternel.",
    e: "Racine primaire"
  },
  "H7200": {
    m: "voir, regarder",
    d: "Voir avec les yeux ; percevoir, comprendre ; pourvoir.",
    u: "Utilisé 1311 fois dans l'AT. Dieu vit que cela était bon.",
    e: "Racine primaire"
  },
  "H7225": {
    m: "commencement, prémices",
    d: "Commencement, début ; le meilleur, les prémices.",
    u: "Utilisé 51 fois dans l'AT. 'Au commencement Dieu créa...'",
    e: "De רֹאשׁ (rosh) = tête, commencement"
  },
  "H7257": {
    m: "se coucher, reposer",
    d: "Se coucher, reposer ; demeurer ; couver.",
    u: "Utilisé 30 fois dans l'AT. Il me fait reposer (Ps 23:2).",
    e: "Racine primaire"
  },
  "H7291": {
    m: "poursuivre, chasser",
    d: "Poursuivre, chasser ; persécuter ; suivre de près.",
    u: "Utilisé 144 fois dans l'AT. La bonté me poursuivra.",
    e: "Racine primaire"
  },
  "H7307": {
    m: "esprit, souffle, vent",
    d: "Souffle, vent ; esprit de Dieu ou de l'homme ; disposition mentale.",
    u: "Utilisé 378 fois dans l'AT. L'Esprit de Dieu.",
    e: "De רוּחַ (ruach) = souffler"
  },
  "H7462": {
    m: "paître, berger, nourrir",
    d: "Faire paître un troupeau ; être berger ; nourrir, soigner.",
    u: "Utilisé 173 fois dans l'AT. L'Éternel est mon berger.",
    e: "Racine primaire"
  },
  "H7549": {
    m: "étendue, firmament",
    d: "Étendue, voûte céleste, firmament ; le ciel.",
    u: "Utilisé 17 fois dans l'AT. L'étendue au milieu des eaux.",
    e: "De רָקַע (raqa) = étendre, battre"
  },
  "H7626": {
    m: "bâton, tribu",
    d: "Bâton, verge ; tribu, branche familiale.",
    u: "Utilisé 190 fois dans l'AT. Ton bâton et ta houlette.",
    e: "De שָׁבַט (shabat) = brancher"
  },
  "H7725": {
    m: "retourner, revenir, restaurer",
    d: "Retourner, revenir ; restaurer, renouveler ; se repentir.",
    u: "Utilisé 1058 fois dans l'AT. Restaurer mon âme.",
    e: "Racine primaire"
  },
  "H7979": {
    m: "table",
    d: "Table pour manger ; table des pains de proposition.",
    u: "Utilisé 71 fois dans l'AT. La table préparée.",
    e: "De שָׁלַח (shalach) = envoyer, étendre"
  },
  "H8064": {
    m: "cieux, ciel",
    d: "Cieux, firmament ; demeure de Dieu ; ciel visible.",
    u: "Utilisé 420 fois dans l'AT. Les cieux et la terre.",
    e: "Duel de שָׁמַיִם (shamayim) = hauteurs"
  },
  "H8414": {
    m: "informe, vide, chaos",
    d: "Désert, désolation ; chaos, vide, néant.",
    u: "Utilisé 20 fois dans l'AT. La terre était informe et vide.",
    e: "De תָּהָה (tahah) = errer"
  }
};

export default strongTranslationsFR;
